module.exports = __webpack_public_path__ + "img/MES.3460871e.png";